import React, { useState } from "react";
import "./jnanabhumi.css";
import RoutesComponent from "./routes";


const BlockedSite = () => {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="neterror">
      <div
        className="icon-wrapper"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <div className="icon icon-generic" />
        {hovered && (
          <div className="message">
            <p><strong>{window.location.hostname}</strong> refused to connect.</p>
          </div>
        )}
      </div>
    </div>
  );
};

function App() {
  if (window !== window.top) {
    return (<BlockedSite />)
  }
  else if (window === window.top) {
    return (
      <React.Fragment>
        <RoutesComponent></RoutesComponent>
      </React.Fragment>

    );
  }
}
export default App